import { render } from "./BomHeaderIndicator.vue?vue&type=template&id=33eab8c6&scoped=true"
import script from "./BomHeaderIndicator.vue?vue&type=script&lang=js"
export * from "./BomHeaderIndicator.vue?vue&type=script&lang=js"

import "./BomHeaderIndicator.vue?vue&type=style&index=0&id=33eab8c6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33eab8c6"]])

export default __exports__